import React, {useMemo, useCallback, useEffect} from 'react';
import {ListBoxOptionType} from '@flixbus/honeycomb-react';
import {useAppSelector} from '@/Pages/Common/hooks/useAppSelector';
import {useAppDispatch} from '@/Pages/Common/hooks/useAppDispatch';
import {fetchPlanrLines} from '@/Pages/ProductionCost/store/thunks';
import {updateFilter} from '@/Pages/Home/store/slice';
import CalculationAutocompleteFilter from '../CalculationAutocompleteFilter/CalculationAutocompleteFilter';

const LinesFilter: React.FC = () => {
  const lines = useAppSelector(({productionCost}) => productionCost.lines);
  const dispatch = useAppDispatch();

  const options: ListBoxOptionType[] = useMemo(
    () =>
      lines
        .map(line => ({
          title: line.number as string,
          value: line.uuid
        }))
        .sort((l1, l2) => l1.title.localeCompare(l2.title)),
    [lines]
  );

  const handleSelect = useCallback(
    (selectedOptions: ListBoxOptionType[]) => {
      const value = selectedOptions.map(option => option.value as string);
      dispatch(
        updateFilter({
          field: 'lineNumbers',
          value
        })
      );
    },
    [dispatch]
  );

  useEffect(() => dispatch(fetchPlanrLines()), [dispatch]);

  return (
    <CalculationAutocompleteFilter
      label="Line ID(s)"
      options={options}
      handleSelect={handleSelect}
    />
  );
};

export default React.memo(LinesFilter);
